import * as styles from "./TimePickerArrow.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Popover as BasePopover } from "@base-ui/react/popover";

import { useTimePickerContext } from "./TimePicker.context";
import type { TimePickerArrowProps } from "./TimePicker.types";

export function TimePickerArrow({
  className,
  style,
  ...props
}: TimePickerArrowProps): JSX.Element {
  const { size } = useTimePickerContext();

  return (
    <BasePopover.Arrow
      data-slot="time-picker-arrow"
      className={clsx(styles.arrow({ size }), className)}
      style={{ left: "50%", transform: "translateX(-50%)", ...style }}
      {...props}
    />
  );
}
